import {Box} from "@mui/material";
import {useAppSelector} from "../../../Config/Hooks";
import React from "react";
import InvertersPage from "./inverters/InverterPage";
import {QueryClient, QueryClientProvider} from "react-query";

export default function DashboardPowerPlantInverterPage(){
    const queryClient = new QueryClient();

    const { selectedPowerPlant, selectedEquipment, selectedSkid } = useAppSelector((state) => state.dashboard);
    return(
        <QueryClientProvider client={queryClient}>
            <Box style={{paddingBottom: '20px', paddingTop: 0, marginTop: 0, marginLeft: '10px', marginRight: '10px'}}>
                {selectedPowerPlant ? <InvertersPage powerPlant={selectedPowerPlant} equipment={selectedEquipment} skid={selectedSkid}/>: null}
            </Box>
        </QueryClientProvider>

    );
}
